const hotkeys = {
  GO_SERENE: 'goSerene',
  START_OR_END_SESSION: 'startOrEndSession',
};

module.exports = hotkeys;
